import React from 'react';
import '../styles/components/match-view-toggle.scss';

export type MatchView = 'upcoming' | 'results';

interface MatchViewToggleProps {
  view: MatchView;
  onViewChange: (view: MatchView) => void;
  upcomingCount?: number;
  resultsCount?: number;
}

const MatchViewToggle: React.FC<MatchViewToggleProps> = ({
  view,
  onViewChange,
  upcomingCount,
  resultsCount
}) => {
  return (
    <div className="match-view-toggle">
      <button
        className={`match-view-toggle__button ${view === 'upcoming' ? 'active' : ''}`}
        onClick={() => onViewChange('upcoming')}
        aria-pressed={view === 'upcoming'}
      >
        <span className="button-text">Upcoming</span>
        {upcomingCount !== undefined && (
          <span className="button-count">{upcomingCount}</span>
        )}
      </button>

      <button
        className={`match-view-toggle__button ${view === 'results' ? 'active' : ''}`}
        onClick={() => onViewChange('results')}
        aria-pressed={view === 'results'}
      >
        <span className="button-text">Results</span>
        {resultsCount !== undefined && (
          <span className="button-count">{resultsCount}</span>
        )}
      </button>
    </div>
  );
};

export default MatchViewToggle;
